import {db_url} from "../url";
import axios from "axios";

export default function DB_LogMobile(token) {

    const url = db_url + '/development/logs_mobile'

    const getLogsMobile = (controller, search) => {
        return axios.get(url, {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }

    const getLogMobile = (controller, session_id) => {
        return axios.get(url, {
            signal: controller.signal,
            params: {
                session_id: session_id
            },
            headers: {
                Authorization: token
            }
        })
    }

    return {
        getLogsMobile,
        getLogMobile
    }
}